module.exports = __webpack_public_path__ + "news.00416040af8b2753ba9f.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/backgrounds/news.jpg
// module id = ../../../../../src/assets/images/backgrounds/news.jpg
// module chunks = styles